<template>
  <div class="tab-group">
    <div ref="row" class="tab-group__row">
      <eg-button
        class="tab-group__tab"
        size="medium"
        :data-tab-key="'all'"
        :class="tabClass('all', selectedItem === 'all')"
        data-testid="feedback-items-all-button"
        @click="selectItem('all')"
        >{{ $t("common.showAll") }}</eg-button
      >
      <eg-button
        v-for="item in items"
        :key="item.id"
        class="tab-group__tab"
        size="medium"
        :data-tab-key="String(item.id)"
        :class="tabClass(String(item.id), selectedItem === item.id)"
        @click="selectItem(item.id)"
      >
        <template #icon>
          <div
            class="feedback-item-icon mr-1"
            :style="{
              backgroundColor: item.color,
            }"
          ></div>
        </template>
        {{ item.criteria.name }}
      </eg-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportItems",

  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      firstInRowKeys: [],
      lastInRowKeys: [],
      resizeObserver: null,
    };
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },

  methods: {
    selectItem(itemId) {
      this.$emit("select-item", itemId);
    },

    tabClass(key, isActive) {
      return {
        "tab-group__tab--active": isActive,
        "tab-group__tab--first-in-row": this.firstInRowKeys.includes(key),
        "tab-group__tab--last-in-row": this.lastInRowKeys.includes(key),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-group {
  margin: 0 1.5rem;

  &__row {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }

  &__tab {
    padding: 0.5rem 0.75rem;
    align-items: center;
    line-height: 100%;
    border-radius: 0;
    border: 1px solid #e9ecef;
    font-weight: var(--typography-font-weight-fw-400);
    background: var(--color-surface-primary-light-1, #f6f2ff);

    &:last-of-type:not(:first-of-type),
    &:first-of-type:not(:last-of-type) {
      border-top: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
      border-right: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
      border-left: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
    }
    &:first-of-type:not(:last-of-type) {
      border-radius: var(--radius-rd-300, 8px) 0 0 0;
    }
    &:last-of-type:not(:first-of-type) {
      border-radius: 0 var(--radius-rd-300, 8px) 0 0;
    }

    &:hover,
    &--active {
      background: white !important;
    }
  }

  .feedback-item-icon {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>
